import { Star } from 'lucide-react';
import { useTestimonials } from '@/hooks/use-cro-settings';

const FALLBACK_REVIEWS = [
  {
    id: '1',
    name: 'Marina S.',
    text: 'Entrega estável e suporte respondeu rápido. Usei nos Reels e vi engajamento subir.',
  },
  {
    id: '2',
    name: 'Lucas P.',
    text: 'Checkout PIX simples. Pedido de seguidores Instagram apareceu em minutos.',
  },
  {
    id: '3',
    name: 'Ana R.',
    text: 'Comprei likes no TikTok para o lançamento. Sem pedir senha, processo limpo.',
  },
];

export function ReviewsGrid() {
  const { data } = useTestimonials();
  const reviews =
    data && data.length > 0
      ? data.slice(0, 3).map((t) => ({
          id: t.id,
          name: t.name,
          text: t.content,
          rating: t.rating ?? 5,
        }))
      : FALLBACK_REVIEWS.map((r) => ({ ...r, rating: 5 }));

  return (
    <div className="grid gap-4 md:grid-cols-3">
      {reviews.map((r) => (
        <figure key={r.id} className="rounded-xl border border-border p-4">
          <div
            className="mb-2 flex gap-0.5 text-[var(--color-accent)]"
            aria-label={`${r.rating} de 5`}
          >
            {Array.from({ length: 5 }).map((_, i) => (
              <Star
                key={i}
                className={`h-3.5 w-3.5 ${i < (r.rating ?? 5) ? 'fill-current' : 'opacity-30'}`}
              />
            ))}
          </div>
          <blockquote className="text-sm text-muted">&ldquo;{r.text}&rdquo;</blockquote>
          <figcaption className="mt-2 text-xs font-medium text-fg">{r.name}</figcaption>
        </figure>
      ))}
    </div>
  );
}

export function ScarcityNote({ text }: { text?: string | null }) {
  if (!text?.trim()) return null;
  return (
    <p className="rounded-lg border border-border bg-surface px-3 py-2 text-sm text-muted">
      {text.trim()}
    </p>
  );
}
